import React from 'react';
import { pxToRem } from '../../../utils/dimensionConverter';
import { Icon } from '../icon';

export const Tag = ({
  name,
  handleClick,
  hasClose,
  isDefault,
  isPrimary
}) => {
  return (
    <div className={`table__tag ${isDefault && 'tag-default'} ${isPrimary && 'table__tag--primary'}`}>
      <span>
        {name}
      </span>
      {hasClose && (
        <div className="close-tag" onClick={() => handleClick()}>
          <Icon name="close" size={pxToRem(8)} />
        </div>
      )}
    </div>
  );
};
